export default "/assets/site/images/lodi_edit.png?ed58384fd9f6fee04cd9d32a6fd63ff8";